import { Heart } from "lucide-react";

const ITEMS = [
  "Designed in Britain",
  "Patent Pending",
  "100% Cotton Inserts",
  "BPA Free & Non-Toxic",
  "Everything You Need in One Pack",
  "Coming Soon — Register Your Interest",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="marquee-pause overflow-hidden border-y border-binky-blue/10 bg-white py-5"
  >
    <div className="flex w-max animate-marquee items-center">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center" aria-hidden={half === 1}>
          {ITEMS.map((item, i) => (
            <span
              key={`${half}-${i}`}
              className="flex items-center whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.28em] text-binky-blue/70"
            >
              <span className="px-6">{item}</span>
              <Heart className="h-3.5 w-3.5 shrink-0 fill-binky-pink text-binky-pink" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
